import { DefaultContext } from "constants/context/context";
import { createContext } from "react";

const LoginContext = createContext(DefaultContext);

export default LoginContext;
